import { motion } from 'framer-motion'
import { Shield, ArrowRight } from 'lucide-react'
import FeatureVideo from '../../ui/FeatureVideo'
import featureVideo from '../../../../assets/videos/consultoria.mp4'

const benefits = [
  'Agendamento direto pela plataforma',
  'Consulta especializada e com sigilo garantido',
  'Orientações preventivas para casos sensíveis',
]

export default function Consultancy({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-1/2 flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6 !bg-text-primary !text-white">
          Acesso Premium
        </span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          Um especialista humano a um clique.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-6">
          <span className="hidden md:inline">
            Assinantes do plano Premium contam com consultorias via videochamada. Resolva impasses complexos cara a cara com advogados que compreendem a tensão e a realidade da profissão médica.
          </span>
          <span className="md:hidden">
            Consultorias via videochamada com advogados especialistas em direito médico.
          </span>
        </p>
        <ul className="space-y-3 mb-10">
          {benefits.map((item, idx) => (
            <li
              key={idx}
              className="flex items-center gap-3 text-text-secondary text-[16px]"
            >
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-tint flex items-center justify-center">
                <Shield className="w-3 h-3 text-accent-primary" />
              </div>
              {item}
            </li>
          ))}
        </ul>
        <a href="#planos" className="btn-primary group hidden lg:inline-flex">
          Começar a usar a plataforma
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </motion.div>

      <div className="w-full lg:w-1/2 flex items-center justify-center order-2">
        <FeatureVideo videoSrc={featureVideo} label="Consultoria Jurídica" />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary group w-full justify-center">
          Começar a usar a plataforma
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </div>
    </div>
  )
}
